<div class="flex flex-col text-center">
  @if (hasPermission(permissions.see_energy_meter_knobs)) {
    <app-knob-view [energyMeterList]="energyMeterList()" />
  }
  @if (hasPermission(permissions.see_energy_meter_graph)) {
    <app-graph-view [energyMeterLogInformation]="energyMeterLogInfo()" />
  }
</div>
